/**
 * Enhanced React Native Web compatibility layer
 * Adds missing native-only APIs as no-ops or stubs
 */

// Import react-native-web exports
import * as RNWeb from 'react-native-web';
import EventEmitter from './eventEmitterStub';
import Alert from './alertStub';

// Create a singleton DeviceEventEmitter instance
const deviceEventEmitter = new EventEmitter();

// Export all named exports from react-native-web
export * from 'react-native-web';

// Override with our enhanced versions
export { deviceEventEmitter as DeviceEventEmitter };
export { Alert };

// Export Keyboard with enhanced addListener
export const Keyboard = {
  ...RNWeb.Keyboard,
  addListener: (event: string, callback: () => void) => {
    return { remove: () => {} };
  },
};

// Override Dimensions to constrain width to 520px for web (mobile UI)
const MAX_WEB_WIDTH = 520;

export const Dimensions = {
  ...RNWeb.Dimensions,
  get: (dimension: string) => {
    const original = RNWeb.Dimensions.get(dimension);
    
    // Constrain window width to 520px max for mobile UI on web
    if (dimension === 'window') {
      return {
        ...original,
        width: Math.min(original.width, MAX_WEB_WIDTH),
      };
    }
    
    // Constrain screen width to 520px max for mobile UI on web
    if (dimension === 'screen') {
      return {
        ...original,
        width: Math.min(original.width, MAX_WEB_WIDTH),
      };
    }
    
    return original;
  },
};

// Utility function to center modals on web
export const centerModalOnWeb = (modalElement: HTMLElement | null) => {
  if (!modalElement || typeof window === 'undefined') return;
  
  // Apply centering styles
  if (modalElement.style) {
    modalElement.style.maxWidth = '520px';
    modalElement.style.width = '100%';
    modalElement.style.marginLeft = 'auto';
    modalElement.style.marginRight = 'auto';
    modalElement.style.left = '0';
    modalElement.style.right = '0';
  }
};

